const styles = (theme) => ({
  headerContainer: {
    border: `1px solid ${theme.AppBGColor}`,
    borderRadius : "4px",
  },
  header: {
    marginTop: 8,
    marginBottom: 8,
    marginLeft : 8,
  },
  radioContainer : {
    paddingLeft : 8,
    borderTop : `1px solid ${theme.AppBGColor}`,
    maxHeight : 100,
    overflow : "auto"
  }
});

export default styles;
